import FastFilters from './FastFiltersWrapper';

export default FastFilters;
